import { render, staticRenderFns } from "./SideBarLoader.vue?vue&type=template&id=84e2b0d0"
import script from "./SideBarLoader.vue?vue&type=script&lang=js"
export * from "./SideBarLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports